import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-[#D6E2F0] text-[#0F1E33] overflow-x-hidden">
      <Navbar />
      <main className="bg-[#D6E2F0]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
